import { createContext, useContext } from "react";
import { assert } from "utils";

import { type ExercisesRepository } from "src/repositories/exercises/ExercisesRepository";

export const ExercisesRepositoryContext =
  createContext<ExercisesRepository | null>(null);

export function useExercisesRepository(): ExercisesRepository {
  const repository = useContext(ExercisesRepositoryContext);
  assert(repository, "ExercisesRepositoryContext is missing");
  return repository;
}
